import { render, staticRenderFns } from "./bg.vue?vue&type=template&id=e3a0dd2c&scoped=true&"
import script from "./bg.vue?vue&type=script&lang=js&"
export * from "./bg.vue?vue&type=script&lang=js&"
import style0 from "./bg.vue?vue&type=style&index=0&id=e3a0dd2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a0dd2c",
  null
  
)

export default component.exports